<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" :rules="rules" label-width="180px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderNumber" label="订单编号">
              {{ detail.orderNumber || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderType" label="订单类型">
              {{ detail.orderType == '1' ? '一口价' : '暂定价' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="userName" label="采购方">
              {{ detail.userName || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierName" label="供应商名称">
              {{ detail.supplierName || "" }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="specName" label="规格名称">
              {{ detail.specName || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lockedPrice" label="采购单价(元)">
              {{ detail.lockedPrice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="kyQuantity" label="可用数量">
              {{ detail.kyQuantity || "0" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item prop="lockedList" label="提货单列表">
            <el-row>
              <el-button class="mb15" type="primary" @click="addLockedOrder">新增提货单</el-button>
            </el-row>
            <el-table :data="formData.lockedList">
              <!-- 提货编号 -->
              <el-table-column min-width="160" prop="pickupNumber" label="提货编号"></el-table-column>
              <!-- 提货时间 -->
              <el-table-column min-width="180" prop="vehicleDateStart" label="提货日期"></el-table-column>
<!--               提货单价-->
<!--              <el-table-column min-width="150" prop="pickupPrice" label="提货单价"></el-table-column>-->
              <!-- 可编辑提货数量 -->
              <el-table-column min-width="180" prop="pickupQuantity" label="提货数量">
                <template v-slot="{ row, $index }">
                  <el-form-item :prop="`lockedList.${$index}.pickupQuantity`"
                                :rules="[{ required: true, message: '请输入提货数量' }]">
                    <el-input v-model="row.pickupQuantity" placeholder="请输入提货数量" />
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- 操作删除 -->
              <el-table-column fixed="right" label="操作">
                <template v-slot="{ $index }">
                  <el-button type="text" @click="deleteRow($index)" class="del-btn">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button type="primary" @click="submit">提交</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <YxOrderChoose :visible="showDg" @close="showDg = false" :specId="this.detail.specId" :selectIds="selectIds" @confirm="addLockedList"></YxOrderChoose>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
import YxOrderChoose from '@/views/zhyc/orderManage/YxOrderChoose.vue'
import { validNumber3 } from '@/utils/validator'

export default {
  name: 'Relation',
  components: { YxOrderChoose },
  data() {
    return {
      detail: {
        orderId: '',
        orderNumber: '',
        userId: '',
        specId: '',
        specName: '',
        lockedPrice: '',
        orderQuantity: '',
        usedQuantity: '',
        parentOrderId: '',
        priceDiff: '',
        lockedDeposit: '',
        orderStatus: '',
        isDel: '',
        createUserId: '',
        ctime: '',
        fileList: [],
        recordList: []
      },
      showDg: false,
      selectIds: [],
      rules: {
        lockedList: [{ required: true, message: '请添加提货单数据', trigger: 'change', type: 'array', min: 1 }]
      },
      formData: {
        lockedList: []
      },
      loading: false
    }
  },
  created() {
    if (this.orderId) {
      this.loadData()
    }
  },
  computed: {
    orderId() {
      return this.$route.query.orderId
    },
    orderType() {
      return this.$route.query.orderType
    }
  },
  methods: {
    // 获取订单详情
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.yxcOrderManage.selectYxcPriceOrderByOrderId, {
          params: { orderId: this.orderId }
        })
        .then(res => {
          const orderQuantity = new BigNumber(res.orderQuantity || 0)
          const usedQuantity = new BigNumber(res.usedQuantity || 0)
          const usedAddQuantity = new BigNumber(res.usedAddQuantity || 0)
          const num = orderQuantity.minus(usedQuantity).minus(usedAddQuantity)
          res.kyQuantity = Number(num.toFixed(3))
          this.detail = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    addLockedOrder() {
      if (this.formData.lockedList && this.formData.lockedList.length) {
        this.selectIds = this.formData.lockedList.map(item => item.pickupId)
      } else {
        this.selectIds = []
      }
      this.showDg = true
      console.log('addLockedOrder  selectIds', this.selectIds)
    },
    // 删除单行
    deleteRow(index) {
      this.formData.lockedList.splice(index, 1)
    },
    addLockedList(list) {
      console.log('addLockedList', list)
      const newData = list || []
      newData.forEach(newItem => {
        newItem.realPickupQuantity = newItem.pickupQuantity || '0'
        const existItem = this.formData.lockedList.find(item => item.pickupId === newItem.pickupId)
        if (existItem && existItem.pickupQuantity) {
          newItem.pickupQuantity = existItem.pickupQuantity
        }
      })
      this.formData.lockedList = newData
    },
    // 表单提交
    submit() {
      this.$refs.form.validate().then(() => {
        for (const item of this.formData.lockedList) {
          if (!item.pickupQuantity) {
            this.$message.error('请输入提货数量')
            return
          }
          if (!validNumber3.test(item.pickupQuantity)) {
            this.$message.error('提货数量大于0，可保留三位小数')
            return
          }
          // 云采关联提货允许超量，不再按原提货数量限制提交。
        }
        const data = this.formData.lockedList.map(item => {
          return {
            pickupId: item.pickupId,
            pickupQuantity: item.pickupQuantity
          }
        })
        this.loading = true
        this.$axios.post(this.$apis.yxcOrderManage.insertYxcPickupOrderByLockedList, {
          orderId: this.orderId,
          lockedList: data
        }).then(() => {
          this.$router.back()
        }).finally(() => {
          this.loading = true
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 100%;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
